module.exports = __webpack_public_path__ + "media/images/hero_banner_pc-1a0627ec19e086a8d1d0c07901985ceb.png";